import { render, staticRenderFns } from "./TheTopbarNavbarMenuItem.vue?vue&type=template&id=15fbaae7&scoped=true"
import script from "./TheTopbarNavbarMenuItem.vue?vue&type=script&lang=js"
export * from "./TheTopbarNavbarMenuItem.vue?vue&type=script&lang=js"
import style0 from "./TheTopbarNavbarMenuItem.vue?vue&type=style&index=0&id=15fbaae7&prod&scoped=true&lang=css"
import style1 from "@/assets/css/shared-styles/topbar-navbar.css?vue&type=style&index=1&id=15fbaae7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbaae7",
  null
  
)

export default component.exports